import { convertToHttps } from "./common";
function transferInterestList(array) {
    const privilegeList = [];
    if (!array)
        return [];
    array.forEach(res => {
        privilegeList.push({
            label: res.split(':')[0],
            desc: res.split(':')[1]
        });
    });
    return privilegeList;
}
export default function (cardResponseData, props, texReportData) {
    if (!(cardResponseData === null || cardResponseData === void 0 ? void 0 : cardResponseData.productInfoList) || (cardResponseData === null || cardResponseData === void 0 ? void 0 : cardResponseData.productInfoList.length) === 0)
        return [];
    const cardList = [];
    cardResponseData.productInfoList.forEach((data, index) => {
        var _a, _b;
        cardList.push(Object.assign(Object.assign({}, data), { texReportData: texReportData, productId: data.productId, productIdStr: data === null || data === void 0 ? void 0 : data.productIdStr, productType: data.productType, productName: data.productName, productTypeName: data.productTypeName, frontImg: (_a = data.frontImg) === null || _a === void 0 ? void 0 : _a.replace('w.h', '194.368'), bottomTag: data.imgBottomTag, displayScore: props.displayScore, score: data.score, soldInfo: data.saleCount, areaName: (data === null || data === void 0 ? void 0 : data.positionDesc) ? data === null || data === void 0 ? void 0 : data.positionDesc.join('・') : '', privilegeList: transferInterestList(data === null || data === void 0 ? void 0 : data.customInterestList), displayTag: props.displayTag, buyText: props.buyText, averagePrice: (data === null || data === void 0 ? void 0 : data.averagePrice) || '', actualPrice: data.price, originalPrice: data.originalPrice, jumpUrl: data === null || data === void 0 ? void 0 : data.nativeJumpUrl, saveMoneyTag: data === null || data === void 0 ? void 0 : data.saveMoneyTag, recommendReason: data === null || data === void 0 ? void 0 : data.recommendReason, 
            // 亮点特色项列表
            highLightList: (_b = data === null || data === void 0 ? void 0 : data.highLightList) !== null && _b !== void 0 ? _b : [], cardStyleType: props.cardStyleType, cardIndex: index }));
    });
    return cardList;
}
export const formatCardList = (list, props, texReportData) => {
    if (!list || (list === null || list === void 0 ? void 0 : list.length) === 0)
        return [];
    const cardList = [];
    list.forEach((data, index) => {
        var _a, _b, _c, _d, _e;
        cardList.push({
            productId: data.productId,
            productIdStr: data === null || data === void 0 ? void 0 : data.productIdStr,
            productType: data.type,
            productName: data.title,
            productTypeName: data.productTypeName,
            frontImg: convertToHttps((_a = data.headImage) === null || _a === void 0 ? void 0 : _a.replace('w.h', '194.368')),
            bottomTag: data.imgBottomTag,
            displayScore: props.displayScore,
            score: data.score,
            soldInfo: data.salesCount,
            areaName: (data === null || data === void 0 ? void 0 : data.positionInfo) ? data === null || data === void 0 ? void 0 : data.positionInfo.join('・') : '',
            privilegeList: transferInterestList(data === null || data === void 0 ? void 0 : data.customInterestList),
            displayTag: props.displayTag,
            buyText: props.buyText,
            averagePrice: (data === null || data === void 0 ? void 0 : data.avgPriceDesc) || '',
            actualPrice: (_b = data.priceModel) === null || _b === void 0 ? void 0 : _b.sellPrice,
            originalPrice: (_c = data.priceModel) === null || _c === void 0 ? void 0 : _c.originalPrice,
            jumpUrl: (data === null || data === void 0 ? void 0 : data.nativeJumpUrl) || '',
            saveMoneyTag: ((_d = data === null || data === void 0 ? void 0 : data.priceModel) === null || _d === void 0 ? void 0 : _d.discountTag) || '',
            recommendReason: data === null || data === void 0 ? void 0 : data.recommendReason,
            highLightList: (_e = data === null || data === void 0 ? void 0 : data.highLightList) !== null && _e !== void 0 ? _e : [],
            rating: data === null || data === void 0 ? void 0 : data.rating,
            cardStyleType: props.cardStyleType,
            cardIndex: index,
            texReportData: texReportData,
            // 必须传扩展信息，周边游等类型的供给跳转强制需要
            extInfo: data === null || data === void 0 ? void 0 : data.extModel
        });
    });
    return cardList;
};
